import { HTMLAttributes } from 'react';
import { foundationRadiusTokens, foundationSemantic } from '../../foundation';
import { cx } from './utils';

type BadgeVariant = 'default' | 'success' | 'warning' | 'danger' | 'info';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

const variantClasses: Record<BadgeVariant, string> = {
  default: foundationSemantic.badge.default,
  success: foundationSemantic.badge.success,
  warning: foundationSemantic.badge.warning,
  danger: foundationSemantic.badge.danger,
  info: foundationSemantic.badge.info
};

export default function Badge({ variant = 'default', className, ...props }: BadgeProps) {
  return (
    <span
      className={cx(`inline-flex items-center ${foundationRadiusTokens.full} px-2 py-0.5 text-xs font-medium`, variantClasses[variant], className)}
      {...props}
    />
  );
}

export type { BadgeProps, BadgeVariant };
